const EMPLOYEE_FORM = {
  valid: false,
  name: "",
  surname: "",
  nameRules: [
    (v) => !!v || "Pole obowiązkowe",
    (v) =>
      (v && v.length <= 30) || "Pole nie moze zawierać więcej niz 30 znaków",
  ],
  pesel: "",
  peselRules: [
    (v) => !!v || "Pole obowiązkowe",
    (v) => /^[0-9]*$/.test(v) || "Pole powinno zawierać tylko cyfry",
    (v) =>
      (v && v.length <= 11) || "Pole nie moze zawierać więcej niz 11 znaków",
  ],
  employeeNumber: "",
  employeeNumberRules: [
    (v) => !!v || "Pole obowiązkowe",
    (v) => /^[0-9]*$/.test(v) || "Pole powinno zawierać tylko cyfry",
    (v) => (v && v.length <= 6) || "Pole nie moze zawierać więcej niz 6 znaków",
  ],
  password: "",
  passwordRules: [
    (v) => !!v || "Pole obowiązkowe",
    (v) =>
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!.@#$%^&*])(?=.{8,})/.test(v) ||
      "Hasło powinno zawierać minimum 8 znaków, jedną wielką literę, jedną małą literę, jedną cyfrę oraz jeden znak specjalny ! . @ # $ % ^ & *",
  ],
  repeatPassword: "",
  repeatPasswordRules: [
    (v) => !!v || "Pole obowiązkowe",
    (v) =>
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!.@#$%^&*])(?=.{8,})/.test(v) ||
      "Hasło powinno zawierać minimum 8 znaków, jedną wielką literę, jedną małą literę, jedną cyfrę oraz jeden znak specjalny ! . @ # $ % ^ & *",
  ],
};

const POLISH_STUDENT_FORM = {
  valid: false,
  name: "",
  surname: "",
  nameRules: [
    (v) => !!v || "Pole obowiązkowe",
    (v) =>
      (v && v.length <= 30) || "Pole nie moze zawierać więcej niz 30 znaków",
  ],
  index: "",
  indexRules: [
    (v) => !!v || "Pole obowiązkowe",
    (v) => /^[0-9]*$/.test(v) || "Pole powinno zawierać tylko cyfry",
  ],
  pesel: "",
  peselRules: [
    (v) => !!v || "Pole obowiązkowe",
    (v) => /^[0-9]*$/.test(v) || "Pole powinno zawierać tylko cyfry",
    (v) =>
      (v && v.length <= 11) || "Pole nie moze zawierać więcej niz 11 znaków",
  ],
  privateMail: "",
  privateMailRules: [
    (v) => !!v || "Pole obowiązkowe",
    (v) => /^\S+@\S+\.\S+$/.test(v) || "Niepoprawny email",
  ],
  password: "",
  passwordRules: [
    (v) => !!v || "Pole obowiązkowe",
    (v) =>
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!.@#$%^&*])(?=.{8,})/.test(v) ||
      "Hasło powinno zawierać minimum 8 znaków, jedną wielką literę, jedną małą literę, jedną cyfrę oraz jeden znak specjalny ! . @ # $ % ^ & *",
  ],
  repeatPassword: "",
  repeatPasswordRules: [
    (v) => !!v || "Pole obowiązkowe",
    (v) =>
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!.@#$%^&*])(?=.{8,})/.test(v) ||
      "Hasło powinno zawierać minimum 8 znaków, jedną wielką literę, jedną małą literę, jedną cyfrę oraz jeden znak specjalny ! . @ # $ % ^ & *",
  ],
};

const FOREIGN_STUDENT_FORM = {
  valid: false,
  name: "",
  surname: "",
  nameRules: [
    (v) => !!v || "Field required",
    (v) =>
      (v && v.length <= 30) || "Field can not contain more than 30 characters",
  ],
  index: "",
  indexRules: [
    (v) => !!v || "Field required",
    (v) => /^[0-9]*$/.test(v) || "Field should contain only numbers",
  ],
  idCard: "",
  idCardRules: [(v) => !!v || "Field required"],
  privateMail: "",
  privateMailRules: [
    (v) => !!v || "Pole obowiązkowe",
    (v) => /^\S+@\S+\.\S+$/.test(v) || "Niepoprawny email",
  ],
  birthDate: null,
  birthDateRules: [(v) => !!v || "Field required"],
  password: "",
  passwordRules: [
    (v) => !!v || "Field required",
    (v) =>
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!.@#$%^&*])(?=.{8,})/.test(v) ||
      "Password should contain a minimum of 8 characters, one upper case letter, one lower case letter, one number and one special character ! . @ # $ % ^ & *",
  ],
  repeatPassword: "",
  repeatPasswordRules: [
    (v) => !!v || "Field required",
    (v) =>
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!.@#$%^&*])(?=.{8,})/.test(v) ||
      "Password should contain a minimum of 8 characters, one upper case letter, one lower case letter, one number and one special character ! . @ # $ % ^ & *",
  ],
};

export default {
  EMPLOYEE_FORM: EMPLOYEE_FORM,
  POLISH_STUDENT_FORM: POLISH_STUDENT_FORM,
  FOREIGN_STUDENT_FORM: FOREIGN_STUDENT_FORM,
};
